import styled from 'styled-components';
import PrintingCard from './PrintingCard';

export const SCard = styled(PrintingCard) `
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  page-break-inside: avoid;
`;

export const CardWrapper = styled.div`
  padding: ${({ theme }) => theme.metrics.margin}px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const CardContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.margin}px;
`;

export const CardTitle = styled.div`
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 18px;
`;



// WEBPACK FOOTER //
// ./src/common/modules/printing/styles/Card.js